<template>
  <div
    class="slide-verify"
    :class="{ 'slide-verify--success': passed }"
    :style="{ width: width }"
  >
    <div class="slide-verify__bg" :style="{ width: passed ? '100%' : handleLeft + 'px' }"></div>
    <div class="slide-verify__text" v-if="!passed">
      <span v-if="loading">滑动验证加载中…</span>
      <span v-else-if="!challengeId" class="slide-verify__retry" @click="initChallenge">验证初始化失败，点击重试</span>
      <span v-else>请按住滑块，拖动到最右边完成验证</span>
    </div>
    <div class="slide-verify__text slide-verify__text--success" v-else>验证通过</div>
    <div
      class="slide-verify__handle"
      :style="{ left: passed ? '100%' : handleLeft + 'px' }"
      @mousedown.stop.prevent="onDragStart"
      @touchstart.stop.prevent="onDragStart"
    >
      |||
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import axios from "axios"
export default {
  name: 'SlideVerify',
  props: {
    // 允许父组件自定义宽度，如 '336px' 或 '100%'
    width: {
      type: String,
      default: '100%'
    },
    // 获取 challenge 的接口
    challengeUrl: {
      type: String,
      default: '/api/api/login/slide_challenge'
    },
    // challenge 接口方法：get/post
    challengeMethod: {
      type: String,
      default: 'post'
    },
    // 校验滑动轨迹的接口
    verifyUrl: {
      type: String,
      default: '/api/api/login/slide_verify'
    },
    // verify 接口方法：get/post
    verifyMethod: {
      type: String,
      default: 'post'
    },
    // verify 时附加参数（如 sys_type）
    verifyExtraParams: {
      type: Object,
      default: function () { return {} }
    },
    // 是否发送 points_json（有些后端不需要/可能不接受）
    includePointsJson: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      dragging: false,
      startX: 0,
      handleLeft: 0,
      passed: false,
      challengeId: '',
      loading: false,
      startTime: 0,
      points: []
    }
  },
  mounted () {
    document.addEventListener('mousemove', this.onDragMove)
    document.addEventListener('mouseup', this.onDragEnd)
    document.addEventListener('touchmove', this.onDragMove)
    document.addEventListener('touchend', this.onDragEnd)
    this.initChallenge()
  },
  beforeDestroy () {
    document.removeEventListener('mousemove', this.onDragMove)
    document.removeEventListener('mouseup', this.onDragEnd)
    document.removeEventListener('touchmove', this.onDragMove)
    document.removeEventListener('touchend', this.onDragEnd)
  },
  methods: {
    request (method, url, payload) {
      const m = (method || 'post').toLowerCase()
      const config = { method: m, url }
      if (m === 'get') config.params = payload || {}
      else config.data = payload || {}
      return axios(config)
    },
    normalizePoints (points) {
      const arr = Array.isArray(points) ? points.slice() : []
      if (arr.length === 0) return arr
      // 后端要求至少 3 个点；不足时用最后一个点补齐
      while (arr.length < 3) {
        const last = arr[arr.length - 1]
        arr.push({ x: last.x, t: last.t })
      }
      return arr
    },
    initChallenge () {
      const self = this
      self.passed = false
      self.handleLeft = 0
      self.challengeId = ''
      self.loading = true
      self.startTime = 0
      self.points = []
      self.request(self.challengeMethod, self.challengeUrl, {}).then(function (res) {
        const body = res && res.data ? res.data : null
        // 兼容不同后端返回格式：{code:1000,data:{challenge_id}} / {code:'200',data:{challenge_id}} / {challenge_id:...}
        const code = body ? body.code : undefined
        const ok = code === 1000 || code === '1000' || code === 200 || code === '200' || code === 0 || code === '0' || code === undefined
        const data = body && body.data ? body.data : body
        const challengeId =
          (data && (data.challenge_id || data.challengeId || data.id)) ||
          (body && (body.challenge_id || body.challengeId || body.id)) ||
          ''
        if (ok && challengeId) {
          self.challengeId = challengeId
        } else {
          console.log('[SlideVerify] challenge response:', body)
        }
      }).finally(function () {
        self.loading = false
      })
    },
    onDragStart (e) {
      if (this.passed || this.loading) return
      if (!this.challengeId) {
        this.initChallenge()
        return
      }
      this.dragging = true
      this.startX = e.clientX || (e.touches && e.touches[0].clientX)
      this.startTime = Date.now()
      this.points = [{ x: this.handleLeft, t: 0 }]
    },
    onDragMove (e) {
      if (!this.dragging || this.passed) return
      const clientX = e.clientX || (e.touches && e.touches[0].clientX)
      if (!clientX) return
      const delta = clientX - this.startX
      const trackWidth = this.$el.offsetWidth
      const handleWidth = 40
      const maxLeft = trackWidth - handleWidth
      let nextLeft = this.handleLeft + delta
      if (nextLeft < 0) nextLeft = 0
      if (nextLeft > maxLeft) nextLeft = maxLeft
      this.startX = clientX
      this.handleLeft = nextLeft
      const now = Date.now()
      const dt = this.startTime ? (now - this.startTime) : 0
      this.points.push({ x: nextLeft, t: dt })
      if (nextLeft >= maxLeft) {
        this.dragging = false
        this.verifySlide()
      }
    },
    onDragEnd () {
      if (!this.dragging || this.passed) {
        this.dragging = false
        return
      }
      this.dragging = false
      this.handleLeft = 0
      this.points = []
    },
    reset () {
      this.dragging = false
      this.handleLeft = 0
      this.passed = false
      this.startTime = 0
      this.points = []
      this.initChallenge()
    },
    verifySlide () {
      const self = this
      if (!self.challengeId) {
        self.reset()
        return
      }
      const points = self.normalizePoints(self.points)
      const payload = Object.assign({}, self.verifyExtraParams || {}, {
        challenge_id: self.challengeId,
        // 兼容后端 points / points_json 二选一；后端优先读 points
        points
      })
      if (self.includePointsJson) {
        payload.points_json = JSON.stringify(points)
      }
      self.request(self.verifyMethod, self.verifyUrl, payload).then(function (res) {
        const body = res && res.data ? res.data : null
        const code = body ? body.code : undefined
        const ok = code === 1000 || code === '1000' || code === 200 || code === '200' || code === 0 || code === '0' || code === undefined
        const data = body && body.data ? body.data : body
        const token = data ? (data.slide_token || data.slideToken || data.token) : ''
        if (ok && token) {
          self.passed = true
          self.$emit('passed', token)
        } else {
          console.log('[SlideVerify] verify response:', body)
          self.reset()
        }
      }).catch(function () {
        self.reset()
      })
    }
  }
}
</script>

<style scoped>
.slide-verify {
  position: relative;
  height: 40px;
  line-height: 40px;
  background: #f0f0f0;
  border-radius: 4px;
  user-select: none;
  overflow: hidden;
  font-size: 12px;
  color: #666;
}
.slide-verify__bg {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  background: #b3e19d;
  transition: width 0.2s;
}
.slide-verify__text {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  text-align: center;
  z-index: 1;
}
.slide-verify__retry {
  color: #f56c6c;
  cursor: pointer;
}
.slide-verify__text--success {
  color: #409eff;
}
.slide-verify__handle {
  position: absolute;
  top: 0;
  width: 40px;
  height: 100%;
  background: #fff;
  border-left: 1px solid #dcdfe6;
  box-shadow: 0 0 3px rgba(0, 0, 0, 0.2);
  text-align: center;
  cursor: pointer;
  z-index: 2;
}
.slide-verify--success .slide-verify__handle {
  left: 100% !important;
  margin-left: -40px;
}
</style>




// WEBPACK FOOTER //
// src/components/SlideVerify.vue